<template>
    <div class="wxb-photos">


        <!--            <div slot="title" class="wxb-photos-title">-->
        <!--             -->
        <!--                <span v-if="type == 2">上传图片</span>-->
        <!--            </div>-->

        <el-drawer  :append-to-body="true"
                :with-header="false"
                :modal-append-to-body="false"
                :visible.sync="showPhoto"
                size="50%"
                center
                :before-close="handleClose"
                :modal="false"
        >
            <!--                        最外层-->
            <div class="photos-wrap flex" v-if="type == 1">

                <div class="warp-l">
                    <ul>
                        <li :class="{'activation':item.cat_id == selectedCatId}"
                            @click="selectedCat(item.cat_id)"
                            v-for="(item,key) in cats" :key="key">{{item.cat_name}}
                        </li>
                    </ul>
                </div>
                <div class="warp-r">
                    <div class="warp-r-t flex ">
                        <div class="flex">
                            <el-input class="mr20" v-model="keywords"></el-input>
                            <el-button type="primary" @click="getRes">搜索</el-button>
                        </div>
                        <div>
                               <span >当前已选张数 <span
                               style="color: red;font-weight: bold">{{selectedPhotos.length}}</span> 张</span>
                        </div>
                        <el-button class="upload-btn" @click="type = 2">上传素材</el-button>
                    </div>
                    <div class="warp-r-m">
                        <div class="photos-list" v-loading="loading">
                            <div class="photos-item " @click="selected(i)" v-for="(i,k) in datas.list" :key="k">
                                <img :class="{'photos-selected':selectedPhotos.indexOf(i.url) > -1}"
                                     class="photo-select-icon                 "
                                     src="@/assets/images/icon_selected.png"/>
                                <el-image class="photo-image" :src="i.url" fit="cover" lazy></el-image>
                                <p class="text-over photo-title">{{i.title}}</p>
                            </div>
                            <no-data v-if="!loading && datas.list.length <= 0"></no-data>
                        </div>
                    </div>

                    <div class="warp-r-b mt10">
                        <div class="photos-page flex space pl10 pr10">
                            <div>
                                <el-button type="primary" @click="submit">确 定</el-button>
                            </div>
                            <div>
                                <el-pagination
                                        background
                                        @current-change="getRes"
                                        layout="total,prev, pager, next"
                                        :page-size="datas.limit"
                                        :total="datas.count">
                                </el-pagination>
                            </div>
                        </div>
                    </div>
                </div>


            </div>

            <div v-if="type == 2">
                <el-form ref="form" label-width="100px" style="padding-top: 20px">
                    <el-form-item label="素材分类：" v-loading="catAddloading">
                        <el-col :span="6">
                            <el-select v-model="add_all_category_id" placeholder="请选择">
                                <el-option

                                        v-for="item in cats"
                                        :key="item.cat_id"
                                        :label="item.cat_name"
                                        :value="item.cat_id">
                                </el-option>
                            </el-select>
                        </el-col>
                        <el-col :span="6" :offset="1" v-if="catAdd">
                            <el-input v-model="addCatTitle" placeholder="请输入分类名称"></el-input>
                        </el-col>
                        <el-col :span="3" :offset="1">
                            <el-button type="primary" v-if="catAdd" @click="createCat">提交分类</el-button>
                            <el-button type="primary" v-if="catAdd == false" @click="catAdd = true,addCatTitle=''">
                                添加分类
                            </el-button>
                        </el-col>
                        <el-col :span="2">
                            <el-button v-if="catAdd" @click="catAdd = false,addCatTitle=''">取消</el-button>
                        </el-col>
                    </el-form-item>
                    <el-form-item label="上传图片" class="mt50">
<!--                           :headers="{token:$store.getters.token}"-->
                        <el-upload class="wxb-uploadphotos"
                                   :on-exceed="tisLimit"
                                   ref="uploadphoto2"
                                   :limit="multi?10:1"
                                   :data="getParam()"

                                   list-type="picture-card"
                                   :on-success="handleAvatarSuccess"
                                   :before-upload="beforeAvatarUpload"
                                   :action="getaction()">
                            <i class="el-icon-upload"></i>
                        </el-upload>
                        <p class="wxb-form-tips">单次最多可以选择{{multi?10:1}}张图片</p>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="submit">确 定</el-button>
                        <el-button @click="type = 1">返回列表</el-button>
                    </el-form-item>
                </el-form>
            </div>

        </el-drawer>

    </div>
</template>


<script>
    import {geCattCountIndex, createCat} from "../../request/api/resource/category";
    import {getIndex} from "../../request/api/resource/resource";
    import NoData from "../NoData";

    export default {
        name: "Photos",
        components: {NoData},
        props: {
            showPhoto: {default: false},
            multi: {default: false},
        },
        data() {
            return {
                imageUrl: '',
                photo: '',
                datas: [],
                loading: false,
                cats: [],
                selectedCatId: -1,
                add_all_category_id: -1,
                selectedPhotos: [],
                type: 1, //1 素材列表 2上传素材
                catAdd: false,
                keywords: '',
                addCatTitle: "",
                catAddloading: false,
            }
        },
        created() {
            this.getCatList();
            this.getRes();
        },
        methods: {
            handleAvatarSuccess(res) {
                this.page = 1;
                this.selectedCatId = this.add_all_category_id;
                this.selected({
                    url: res.data.img_url,
                });
                this.getRes();
            },
            beforeAvatarUpload(file) {
                const isLt2M = file.size / 1024 / 1024 < 2;
                if (!isLt2M) {
                    this.$message.warning('上传头像图片大小不能超过 2MB!');
                }
                return isLt2M;
            },
            submit() {
                let photo = "";
                if (this.multi) {
                    photo = this.selectedPhotos;
                } else {
                    let photoa = this.selectedPhotos[0] ? this.selectedPhotos[0] : '';
                    photo = JSON.parse(JSON.stringify(photoa));
                }
                this.$emit("input", false);
                this.$emit("select", photo);
                this.selectedPhotos = [];
            },
            createCat() {
                this.catAddloading = true;
                createCat({
                    cat_name: this.addCatTitle,
                }).then(() => {
                    this.catAddloading = false;
                    this.getCatList();
                    this.catAdd = false;
                    this.addCatTitle = "";
                }).catch(() => {
                    this.catAddloading = false;
                });
            },
            //是否选中
            selected(val) {
                let index = this.selectedPhotos.indexOf(val.url);
                if (index > -1) {
                    this.selectedPhotos.splice(index, 1);
                } else {
                    if (this.multi == false) {
                        this.selectedPhotos = [];
                    }
                    this.selectedPhotos.push(val.url);
                }
            },

            selectedCat(cat_id) {
                this.selectedCatId = cat_id;
                this.getRes(1);
            },

            handleClose() {
                this.$emit("input", false);
            },

            getRes(page = 1) {
                this.loading = true;
                getIndex({
                    category_id: this.selectedCatId,
                    page: page,
                    keywords: this.keywords,
                    limit: 100,
                }).then(res => {
                    this.datas = res;
                    this.loading = false;
                }).catch(() => {
                    this.loading = false;
                });
            },
            async getCatList() {
                this.cats = await geCattCountIndex();
            },

            AddPhoto() {
                if (this.$refs.uploadphoto2) {
                    this.$refs.uploadphoto2.clearFiles();
                }
                this.type = 2;
                this.addPhoto = true;
            },

            tisLimit() {
                let msg = `单次最大上传${this.multi ? 10 : 1}张图片`;
                this.$message(msg)
            },

            okAddPhoto() {
                this.addPhoto = false;
                this.getCatList();
                this.getRes(1)
            },

            getaction() {
                return process.env.VUE_APP_STATUS_API + "/admin/upload/image";
            },
            getParam() {
                return {
                    category_id: this.add_all_category_id <= -1 ? 0 : this.add_all_category_id,
                    token:this.$store.getters.token
                }
            },
        },
    }
</script>


<style lang="scss" scoped>
.drawerBody {
    position: relative;
    z-index: 999999;
}
    .upload-btn {
        background-color: #FF9600;
        border: 1px solid #FF9600;
        color: #FFFFFF
    }

    .photos-wrap {
        .warp-l {
            width: 115px;
            background: rgba(241, 242, 246, 1);
            height: 100vh;
            padding-top: 90px;

            ul {
                width: 100%;

                li {
                    height: 38px;
                    line-height: 38px;
                    padding: 0 10px;
                    color: #333333;
                    cursor: pointer;
                }

                .activation {
                    color: #007EFF;
                }
            }
        }

        .warp-r {
            flex: 1;
            padding: 24px;

            .warp-r-t {
                justify-content: space-between;
                width: 100%;
            }

            .photos-list {
                height: calc(100vh - 150px);
                overflow-y: auto;
                margin-top: 20px;
                .photos-item {
                    float: left;
                    margin-top: 20px;
                    margin-right: 20px;
                    position: relative;
                    width: 164px;
                    height: 194px;
                    cursor: pointer;
                    .photo-select-icon{
                        position: absolute;
                        top: 0;
                        right: 0;
                        z-index: 9;
                        display: none;
                    }
                    .photos-selected{
                        display: block;
                    }
                    .photo-image {
                        width: 164px;
                        height: 164px;
                        border-radius: 6px;
                        border: 2px solid #dcdfe6;
                    }
                    .photo-title{
                        margin-bottom: 10px;
                        margin-top: -10px;
                        text-align: center;
                    }
                }
            }

        }
    }
</style>


<!--<style lang="scss" scoped>-->
<!--    .wxb-uploadphotos {-->
<!--        .el-upload&#45;&#45;picture-card {-->
<!--            width: 100px;-->
<!--            height: 100px;-->
<!--        }-->

<!--    }-->

<!--    .wxb-photos {-->

<!--        .wxb-photos-title {-->
<!--            border-bottom: 1px solid #e1e1e1 !important;-->
<!--            height: 33px;-->
<!--            line-height: 15px;-->
<!--        }-->

<!--        .photo-photo-cat-box {-->
<!--            height: 526px;-->
<!--            margin-top: 10px;-->

<!--            .photo-upload-btn {-->
<!--                height: 40px;-->
<!--                width: 100px;-->
<!--                font-size: 14px-->
<!--            }-->

<!--            .photo-photo-cat {-->
<!--                height: 456px;-->
<!--                overflow-y: auto;-->
<!--                margin-top: 10px;-->


<!--                .select-cat {-->
<!--                    background-color: var(&#45;&#45;main-color);-->
<!--                    color: #ffffff;-->
<!--                    font-weight: bold;-->
<!--                }-->
<!--            }-->
<!--        }-->

<!--        .photo-item-box {-->
<!--            height: 524px;-->

<!--            .photo-item {-->
<!--                margin: 8px;-->
<!--                border: 2px solid #f5f5f5;-->
<!--                cursor: pointer;-->
<!--                float: left;-->
<!--                position: relative;-->

<!--                .photos-selected-icon {-->
<!--                    position: absolute;-->
<!--                    right: 0;-->
<!--                    display: none;-->
<!--                    z-index: 999;-->
<!--                }-->
<!--            }-->

<!--            .photos-selected {-->
<!--                border: 2px solid var(&#45;&#45;main-color);-->

<!--                .photos-selected-icon {-->
<!--                    display: block;-->
<!--                }-->
<!--            }-->

<!--            .photo-page {-->
<!--                width: 100%;-->
<!--                text-align: center-->
<!--            }-->
<!--        }-->


<!--    }-->

<!--    .el-dialog__close, .el-icon, .el-icon-close {-->
<!--        position: relative;-->
<!--    }-->
<!--</style>-->
